import { deriveYesNoString as deriveYesNoStringData } from "@/metrics/runtime/record-data"

export const deriveYesNoString = (
  mo: Parameters<typeof deriveYesNoStringData>[0],
): ReturnType<typeof deriveYesNoStringData> => deriveYesNoStringData(mo)
